// extracted by mini-css-extract-plugin
module.exports = {"browseDetailsButton":"detail-spare-parts_browseDetailsButton__K1YoH"};